(function (window, document) {
    'use strict';

    // Sperrt gegen überlappende Requests, z.B. wenn ungeduldig ein zweites Mal
    // Enter gedrückt wird, während der DOM-Austausch der ersten Anfrage noch
    // läuft. Ohne das kann ein zweiter Submit auf einem gerade ausgetauschten
    // Formular-Fragment landen und zu einer echten (natürlichen) Formular-
    // Absendung statt einem Ajax-Request führen.
    let requestInFlight = false;

    function initSearchForm() {
        const form = document.getElementById('form_kesearch_pi1');
        if (!form) return;

        // doppelte Bindung vermeiden
        if (form.dataset.bound === '1') return;
        form.dataset.bound = '1';

        function triggerSearch() {
            if (requestInFlight) return;
            requestInFlight = true;

            const params = new URLSearchParams(new FormData(form));
            let pending = 0;

            const onDone = function () {
                pending -= 1;
                if (pending <= 0) requestInFlight = false;
            };

            // Formular (Tabs etc.)
            pending += 1;
            sendRequest(params, 'form_kesearch_pi1', 1703833042, onDone);

            // Ergebnisliste
            if (document.getElementById('datamints-search-results')) {
                pending += 1;
                sendRequest(params, 'datamints-search-results', 1703829114, onDone);
            } else if (document.getElementById('kesearch_results')) {
                pending += 1;
                sendRequest(params, 'kesearch_results', 1703829114, onDone);
            }
        }

        if (!form.classList.contains('no-auto-change')) {
            form.addEventListener('change', triggerSearch);

            // Verhindert, dass Enter im Suchwortfeld (oder ein Submit-Button) ein
            // natives Full-Page-Submit auslöst - sonst landet man auf der
            // eigentlich nur für AJAX gedachten Ergebnis-URL.
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                triggerSearch();
            });
        }
    }

    function stableBaseUrl() {
        const form = document.getElementById('form_kesearch_pi1');
        // Bevorzugt data-baseurl (ohne Query!), fällt zurück auf aktuelle Seite
        const raw = (form && form.dataset.baseurl) || (form && form.getAttribute('action')) || (window.location.pathname);
        // URL-Objekt sorgt dafür, dass wir nie Query-Fragmente „mischen“
        return new URL(raw, window.location.origin);
    }

    function sendRequest(formParams, elementToChange, typeNum, onDone) {
        const xhttp = new XMLHttpRequest();

        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    const target = document.getElementById(elementToChange);
                    if (target) {
                        target.innerHTML = this.responseText;

                        // ke_search spiegelt den aktuellen "type"-Parameter (hier: unsere
                        // Ajax-typeNum) als verstecktes Feld ins Formular zurück. Bleibt das
                        // stehen, "vergiftet" es jede spätere native Formular-Absendung, die
                        // dann auf der ungestylten Ajax-Antwort statt der normalen Seite landet.
                        const strayType = target.querySelector('input[name="type"]');
                        if (strayType) strayType.remove();

                        initSearchForm(); // Re-bind nach jedem Reload
                    }
                }
                if (onDone) onDone();
            }
        };

        // URL sauber aufbauen
        const url = stableBaseUrl();
        const sp = new URLSearchParams(url.search); // evtl. vorhandene Query der Basis-URL
        // zuerst alle Form-Parameter übernehmen
        for (const [k, v] of formParams.entries()) sp.set(k, v);
        // type **immer** setzen/überschreiben
        sp.set('type', String(typeNum));
        url.search = sp.toString();

        // Debug bei Bedarf: console.log('AJAX URL →', url.toString());

        xhttp.open('GET', url.toString());
        xhttp.send(null);
    }

    document.addEventListener('DOMContentLoaded', initSearchForm);
})(window, document);
